module.exports = __webpack_public_path__ + "img/TeenBull.01308.f778c532.webp";